import React, { Component } from 'react';
import styled from 'styled-components';
import PdfIcon from '../assets/pdf-icon.png';
import XlsIcon from '../assets/xls-icon.png';
import { defaultFont, headersFont } from '../consts/index'

const Date = styled.div`
  color: grey;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
`;
const ItemsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
`
const InformationWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  max-width: 80%;
`
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 10px;
  height: 70px;
  justify-content: space-evenly;
`

const SectionDescription = styled.span`
  font-family: ${headersFont};
  font-weight: 700;
  text-align: left;
  margin-bottom: 10px;
`

const Button = styled.button`
  font-family: ${defaultFont};
  font-weight: 300;
  text-align: center;
  display: inline-block;
  background-color: #3046ff;
  padding:  15px 30px;
  color: white;
  border: none;
  outline: none;
  font-size: 17px;
  margin: 20px 0;
  cursor: pointer;
`;

const Icon = styled.img`
  height: 65px;
  padding: 10px;
`

export default class ForInvestorsItem extends Component {
  render() {
    const { icon, description, date, url } = this.props;
    const currentDate = date.split("T")[0].split("-");

    return (
      <ItemsWrapper>
        <InformationWrapper>
          <Icon src={icon === "pdf" ? PdfIcon : XlsIcon} alt="Pdf logo" />
          <ContentWrapper>
            <SectionDescription>{description}</SectionDescription>
            <Date>{`${currentDate[2]}.${currentDate[1]}.${currentDate[0]}`}</Date>
          </ContentWrapper>
        </InformationWrapper>
        <a href={url} target="_blank">
          <Button type="submit">Pokaż</Button>
        </a>
      </ItemsWrapper>
    );
  }
}





// WEBPACK FOOTER //
// ./src/pages/ForInvestors/ForInvestorsItem/ForInvestorsItem.jsx